import { useTranslation } from 'react-i18next';

interface CaptchaHelpProps {
  type: 'click' | 'slider' | 'rotate';
}

/** Short goal line plus numbered steps explaining how to solve the puzzle. */
export function CaptchaHelp({ type }: CaptchaHelpProps) {
  const { t, i18n } = useTranslation();
  const steps = t(`captcha.${type}.steps`, { returnObjects: true }) as unknown;

  return (
    <div className="captcha-help" dir={i18n.dir?.() ?? 'ltr'}>
      <p className="captcha-instruction">{t(`captcha.${type}.instruction`)}</p>
      {Array.isArray(steps) && (
        <ol className="captcha-steps">
          {steps.map((step: string, index: number) => (
            <li key={index}>{step}</li>
          ))}
        </ol>
      )}
    </div>
  );
}
